module.exports = "<div class=\"container mainBox\">\r\n<div id=\"particles-js\">\r\n</div>\r\n</div>\r\n"